import { create } from 'zustand'
import type { SelectedEdge, SelectedNode } from '@/components/neo4j/cytoscape/types'
import type { Person } from '@/services/api/graph'

export type PureTimelineSelection =
  | { kind: 'node'; id: string }
  | { kind: 'edge'; id: string }
  | null

interface PureTimelineState {
  selection: PureTimelineSelection
  selectedNodeDetails: SelectedNode | null
  selectedEdgeDetails: SelectedEdge | null
  fullNodeDetails: Person | null
  isFetchingNodeDetails: boolean
  view: { start: string; end: string } | null

  select: (
    sel: PureTimelineSelection,
    details?: { node?: SelectedNode | null; edge?: SelectedEdge | null }
  ) => void
  clearSelection: () => void
  setFullNodeDetails: (details: Person | null) => void
  setFetchingNodeDetails: (fetching: boolean) => void
  setView: (start: string, end: string) => void
  reset: () => void
}

export const usePureTimelineStore = create<PureTimelineState>(set => ({
  selection: null,
  selectedNodeDetails: null,
  selectedEdgeDetails: null,
  fullNodeDetails: null,
  isFetchingNodeDetails: false,
  view: null,

  select: (sel, details) =>
    set({
      selection: sel,
      selectedNodeDetails: details?.node ?? null,
      selectedEdgeDetails: details?.edge ?? null,
      fullNodeDetails: null,
      isFetchingNodeDetails: false,
    }),

  clearSelection: () =>
    set({
      selection: null,
      selectedNodeDetails: null,
      selectedEdgeDetails: null,
      fullNodeDetails: null,
      isFetchingNodeDetails: false,
    }),

  setFullNodeDetails: details => set({ fullNodeDetails: details }),
  setFetchingNodeDetails: fetching => set({ isFetchingNodeDetails: fetching }),
  setView: (start, end) => set({ view: { start, end } }),

  reset: () =>
    set({
      selection: null,
      selectedNodeDetails: null,
      selectedEdgeDetails: null,
      fullNodeDetails: null,
      isFetchingNodeDetails: false,
      view: null,
    }),
}))
